import { AnalyticsEvent } from '../entities/analytics-event.entity';

export const AnalyticsEvents: { [name: string]: AnalyticsEvent } = {
  submit: {
    name: 'submit',
    category: 'submit_application',
    context: 'review',
    label: 'Submit application',
    url: '/application/{applicationId}/review', //do not want to store unique application id's. just use the root
    targetElement: null, //null because submit is explicitly triggered from submit button
  },
  verifyAccount: {
    name: 'link-click',
    category: 'verify_account',
    context: 'dashboard',
    label: null, //automatically pull fron anchor innerText
    targetElement: '.gaTrackEvent-verifyAccount', //this will be anchor tags that exists as HTML in const files
  },
  startApplication: {
    name: 'button-click',
    category: 'start_application',
    context: 'dashboard',
    label: '+ Start a new application', //automatically pull fron anchor innerText
  },
  signatureRequestOptionDownload: {
    name: 'radio-click',
    category: 'signature_option_selected',
    context: 'spouse_signature',
    label: null, //dynamically loaded from label
    input: 'download',
    interaction: null,
    url: '/application/{applicationId}/review',
  },
  signatureRequestOptionOptOut: {
    name: 'radio-click',
    category: 'signature_option_selected',
    context: 'spouse_signature',
    label: null, //dynamically loaded from label
    input: 'opt_out',
    interaction: null,
    url: '/application/{applicationId}/review',
  },
  signatureRequestSendInvitation: {
    name: 'button-click',
    category: 'signature_option_selected',
    context: 'spouse_signature',
    label: `Send invitation`,
    input: 'email',
    interaction: null,
    url: '/application/{applicationId}/review',
  },
  signatureRequestResendInvitation: {
    name: 'button-click',
    category: 'resend_invite_clicked',
    context: 'spouse_signature',
    label: `Resend invite`,
    url: '/application/{applicationId}/review',
  },
  mySituationOnBehalf: {
    name: 'radio-click',
    category: 'mysituation_onbehalf',
    context: 'my_situation',
    label: null, //this will be populated with question
    input: null, //this will be populated with answer
    url: '/application/{applicationId}/mysituation',
  },
  applicationHeaderSave: {
    name: 'button-click',
    category: 'save_application',
    context: 'application_header',
    label: 'Save', //this will be populated with question
    input: null, //this will be populated with answer
    url: '/application/{applicationId}',
  },
};
